import React, { Fragment, useState, useEffect } from "react";
import Input from "../../Input";
import Link from "../../Link";
import { fetchJson } from "../../../lib/Fetching";
import classNames from "classnames";

export default function AliquotInput({
  onAliquotChange,
  onSampleChange,
  minimal = false,
  onCleared,
}) {
  const [returnId, setReturnId] = useState("aliquot_id");
  const [input, setInput] = useState("");
  const [message, setMessage] = useState(
    "Warnings and errors during scanning will appear here"
  );
  const [aliquots, setAliquots] = useState([]);
  const [scanStatus, setScanStatus] = useState("none");
  const [duplicateScanCount, setDuplicateScanCount] = useState(0);
  const [errorScanCount, setErrorScanCount] = useState(0);

  const updateAliquots = (aliquots) => {
    setAliquots(aliquots);
    if (returnId === "aliquot_id") {
      onAliquotChange(aliquots.map((a) => a.id));
      onSampleChange([]);
    }
    if (returnId === "sample_id") {
      onSampleChange(aliquots.map((a) => a.sample_id));
      onAliquotChange([]);
    }
    if (aliquots.length === 0 && onCleared) {
      onCleared();
    }
  };

  useEffect(
    () => {
      if (aliquots.length > 0) {
        updateAliquots(aliquots);
      }
    },
    [returnId]
  );

  const addAliquotReference = () => {
    if (!input || !input.trim()) return;
    fetchJson("/scheduling/aliquots.json", { search: input }).then((json) => {
      if (json.error) {
        setMessage(json.error);
        setScanStatus("error");
        setErrorScanCount(errorScanCount + 1);
      } else {
        if (Array.isArray(json)) {
          const newAliquotIds = json.map((a) => a.id);
          const aliquotsToAdd = aliquots.filter((a) => !newAliquotIds.includes(a.id));
          const duplicateAliquotCount = aliquots.length - aliquotsToAdd.length;
          updateAliquots(aliquotsToAdd.concat(json));
          if (duplicateAliquotCount > 0) {
            setMessage(
              duplicateAliquotCount + " of these aliquots have already been scanned."
            );
            setScanStatus("warning");
            setDuplicateScanCount(duplicateScanCount + 1);
            return;
          }
        } else {
          if (aliquots.filter((a) => a.id === json.id).length > 0) {
            setMessage("You have already scanned this aliquot.");
            setScanStatus("warning");
            setDuplicateScanCount(duplicateScanCount + 1);
            return;
          }
          updateAliquots(aliquots.concat(json));
        }
        setMessage("Scanned successfully");
        setScanStatus("success");
        setInput("");
      }
    });
  };

  const clearAll = () => updateAliquots([]);

  const removeAliquot = (aliquot) => {
    updateAliquots(aliquots.filter((a) => a !== aliquot));
  };

  if (minimal) {
    return (
      <div>
        <div>
          {aliquots.length} aliquots &nbsp;|&nbsp;
          <Link onClick={clearAll}>Clear All</Link>
        </div>
        <Input
          focus
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onPressEnter={() => addAliquotReference()}
          className="form-control"
          placeholder="Scan aliquot barcode..."
          style={{ marginBottom: 10 }}
        />
      </div>
    );
  }

  return (
    <div>
      <Input
        focus
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onPressEnter={() => addAliquotReference()}
        className="form-control"
        placeholder="Scan aliquot / sample /item barcode..."
        style={{ marginBottom: 10 }}
      />
      <div
        className={classNames("alert", {
          "alert-default": scanStatus === "none",
          "alert-success": scanStatus === "success",
          "alert-warning": scanStatus === "warning",
          "alert-danger": scanStatus === "error",
        })}
        style={{ marginBottom: 10 }}
      >
        &nbsp;
        {message}
      </div>

      <div className="alert alert-default" style={{ marginBottom: 10 }}>
        <b>{aliquots.length} aliquots</b>
        &nbsp;&nbsp;|&nbsp;&nbsp; {duplicateScanCount} duplicate scan counts &nbsp;&nbsp;|
        &nbsp;&nbsp;
        {errorScanCount} incorrect scans &nbsp;&nbsp;|&nbsp;&nbsp;
        <input
          type="checkbox"
          onChange={(e) => {
            setReturnId(e.target.checked ? "sample_id" : "aliquot_id");
          }}
          checked={returnId == "sample_id"}
        />{" "}
        Return all the results for the samples associated to the scannned aliquots?
        <div className="pull-right">
          <Link onClick={clearAll}>Clear All</Link>
        </div>
      </div>
      {aliquots.length > 0 && (
        <div style={{ display: "flex", marginBottom: 0, flexWrap: "wrap" }}>
          {aliquots.map((aliquot) => (
            <div className="aliquot-search-item">
              <p>
                <b>{aliquot.identifier}</b>
              </p>
              {aliquot.label_information &&
                aliquot.label_information.map((info) => <p className="info">{info}</p>)}
              <Link onClick={() => removeAliquot(aliquot)}>remove</Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
